import React from "react";
import { Navigate } from "react-router-dom";
import AccessDenied from "./components/AccessDenied";

export const ProtectedRoute = ({ children, roles }) => {
  const authpermission = JSON.parse(localStorage.getItem("auth_permission"));

  if (!authpermission) {
    return <Navigate to="/login" replace />;
  }

  if (authpermission.includes(roles)) {
    return children;
  }

  return <AccessDenied />;
};
